import React from "react";

import { Box } from "@mui/material";

import PageHeader from "../../../components/PageHeader";
import SectionCard from "../../../components/SectionCard";
import CashWithDrawal from "./cashWithDrawal";

const RedemptionClaims = () => {
  return (
    <Box>
      <PageHeader
        title="Redemption Claims"
        crumb="Finance / Redemption Claims"
        subtitle="Cash redemptions · review before payout"
      />

      <SectionCard sx={{ p: 0 }}>
        <Box sx={{ p: 2 }}>
          <CashWithDrawal />
        </Box>
      </SectionCard>
    </Box>
  );
};

export default RedemptionClaims;
